import { createContext, useState } from "react";
import { getFiduciaToken } from "../utils/sessionMethods";
import { apiV1 } from "../lib/axios";
import { useAuth } from "../hooks/useAuth";
import { toast } from "react-toastify";

export const AccountContext = createContext({});

export function AccountProvider({ children }) {
  const [balance, setBalance] = useState();

  const { account, getProfile } = useAuth();

  async function updateBalance() {
    const fiduciaToken = getFiduciaToken();

    await apiV1
      .patch(`/balance/update`, {
        fiduciaToken,
      })
      .catch((err) => {
        console.log(err.message);
      });
  }

  async function getBalance() {
    setBalance(0);

    await updateBalance();

    const response = await apiV1
      .get(`account/show/${account.id}`)
      .then((response) => {
        return response.data.data;
      });

    setBalance(
      Number(response.balance.balance)
        .toFixed(2)
        .toString()
        .replaceAll(".", ",")
    );

    return response.balance.balance;
  }

  async function editPassword(data) {
    await apiV1
      .patch("/account/password/update", data)
      .then(() => {
        toast.success("Senha alterado com sucesso.");
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  }

  async function editAvatar(formData) {
    await apiV1
      .patch("/person/avatar/update", formData)
      .then(async (response) => {
        await getProfile();
        toast.success(response.data.message);
      })
      .catch((err) => {
        console.log("Erro", err);
      });
  }

  async function deleteAvatar() {
    await apiV1
      .delete("/person/avatar")
      .then(async () => {
        await getProfile();
        toast.success("Foto de perfil removida com sucesso.");
      })
      .catch((err) => {
        console.log("Erro", err);
      });
  }

  return (
    <AccountContext.Provider
      value={{
        account,
        balance,
        getBalance,
        editPassword,
        editAvatar,
        deleteAvatar,
      }}
    >
      {children}
    </AccountContext.Provider>
  );
}
